/**
 * 비디오 관련 Write 작업
 *
 * - incrementVideoViewCount() - 비디오 조회수(재생수) 1 증가
 */

import { doc, updateDoc, increment } from "firebase/firestore";
import { firestore } from "/firebaseConfig";

/**
 * 비디오 조회수(재생수) 1 증가
 * Firestore videos/{videoId} 문서의 viewCount 필드를 atomically 증가시킵니다.
 * @param {string} videoId - 비디오 문서 ID
 * @returns {Promise<void>}
 */
export async function incrementVideoViewCount(videoId) {
  if (!videoId) return;
  try {
    const ref = doc(firestore, "videos", String(videoId));
    await updateDoc(ref, { viewCount: increment(1) });
  } catch (error) {
    // 문서가 없거나 권한 문제 시 무시 (조회수 실패가 UX를 막지 않도록)
    console.warn("비디오 조회수 증가 실패:", videoId, error);
  }
}
